(function() {
	/* Tracking Consent functionality */
		
	const startTracking = function() {
		// This should only be run if the user consents to tracking
		document.querySelectorAll('span.allow_marketing_cookies_checkbox').forEach(el => el.checked = true);
	}

	const stopTracking = function() {
	}

	Shopify.loadFeatures([{
		name: 'consent-tracking-api', 
		version: '0.1',
		onLoad: function() {
			if (Shopify.customerPrivacy.userCanBeTracked()) { 
				startTracking();
			} else {
				stopTracking();
			}
		}
	}]);

	document.addEventListener('trackingConsentAccepted', startTracking);

	document.querySelectorAll('span.allow_marketing_cookies_checkbox').forEach(el => {
		var input = document.createElement('input');
		input.type = 'checkbox';
		input.checked = Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.userCanBeTracked();
		el.replaceChildren(input);
		input.addEventListener('change', event => {
			if (Shopify && Shopify.customerPrivacy) {
				Shopify.customerPrivacy.setTrackingConsent(input.checked, function() {});
				if (!input.checked) stopTracking();
			} else {
				alert('Sorry, there was an error changing your cookie preference. Please reload the page and try again.');
				return false;
			}
		});
	});


	/* Pulsing hearts on load */
	window.addEventListener('load', () => {
		var i = 0;
		var ms = 100;
		document.querySelectorAll('.heart-icons__thumb img').forEach(el => {
			this.setTimeout(() => el.classList.add('animate'), ms * i++);
		});
	});


	/* Infinite Scroll */
	infiniteScroll(document.querySelector('.collection'), '.product-grid', {
		paginator: '.pagination-wrapper',
		nextLink: '.pagination-wrapper .pagination__item--prev',
		loading: '<p class="autoload-loading"><span class="loading-spinner">Loading</span></p>',
		more: '<button class="button autoload-more">Load More...</button>',
		sequence: [true, true, false],
	});

	window.addEventListener("load", (event) => {
		document.querySelectorAll('.product .product__media img, .product .thumbnail img').forEach(el => { el.loading = 'eager' });
	});
})();